import { useEffect } from 'react';

/** iOS keeps the layout viewport tall when the keyboard opens. */
export function useVisualViewport(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const root = document.documentElement;
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        // Leave pinch zoom to the browser.
        if (viewport.scale !== 1) return;
        root.style.setProperty('--visual-viewport-height', `${viewport.height}px`);
        root.style.setProperty('--visual-viewport-top', `${viewport.offsetTop}px`);
      });
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      root.style.removeProperty('--visual-viewport-height');
      root.style.removeProperty('--visual-viewport-top');
    };
  }, []);
}
